import { useState } from "react";

import { DetectedFile, FileDisplayProps } from "./types";
import { FileActions } from "./FileDisplayContent/FileActions";
import { FileDisplayContent } from "./FileDisplayContent";

import { useConfirm } from "@/context/confirm-context";
import { ConfirmationModalVariant } from "@/components/ConfirmationModal";

const FileDisplay = ({
  data,
  className,
  onDelete,
  showDeleteButton = false,
  showEditButton = false,
  saveData,
  isInCollection = false,
  detectedFile,
}: FileDisplayProps) => {
  const [isViewing, setIsViewing] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const { confirm } = useConfirm();

  const handleDelete = async () => {
    const isConfirmed = await confirm({
      message: "Are you sure you want to delete this file? This action cannot be undone.",
      headerVariant: ConfirmationModalVariant.destructive,
      saveButtonVariant: "destructiveOutline",
      exitButtonVariant: "outline",
    });
    if (isConfirmed && onDelete) {
      onDelete();
    }
  };

  if (!detectedFile) {
    return (
      <div
        className={`flex items-center justify-center rounded border border-gray-300 bg-gray-50 p-4 ${
          className || ""
        }`}
      >
        <span className="text-gray-500">Unable to process file</span>
      </div>
    );
  }

  return (
    <div className="group/file-item relative w-full overflow-hidden rounded-lg border border-gray-300 bg-gray-50">
      <FileDisplayContent
        data={data}
        detectedFile={detectedFile}
        isViewing={isViewing}
        setIsViewing={setIsViewing}
        saveData={saveData}
        showEditButton={showEditButton}
        isEditing={isEditing}
        isInCollection={isInCollection}
        setIsEditing={setIsEditing}
      />
      <div className="pointer-events-none absolute inset-0 bg-black/0 transition-colors duration-200 group-hover/file-item:bg-black/10" />
      <FileActions
        onView={() => setIsViewing(true)}
        onEdit={showEditButton ? () => setIsEditing(true) : undefined}
        onDelete={showDeleteButton ? handleDelete : undefined}
        onOpenExternal={
          detectedFile.type === "link" ? () => window.open(data, "_blank") : undefined
        }
        showEdit={detectedFile.type === "link" && showEditButton}
        showDelete={showDeleteButton}
        showExternal={detectedFile.type === "link"}
      />
    </div>
  );
};

export default FileDisplay;
export type { FileDisplayProps, DetectedFile };
